import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { CSRF_TOKEN_NAME } from '../../common/api';
import { SYSTEM_ERROR_TYPE } from '../../common/const';
import {
  setSystemLodingFLg,
  setErrorMessage,
} from '../actions/CommonAction';

// 認証状態の判定（未認証の場合、ログイン画面へリダイレクト）
const AuthRoute = (props) => {
  const { userInfo, systemErrorType } = props;
  if (userInfo === null || systemErrorType === SYSTEM_ERROR_TYPE.AUTH_NG) {
    const {
      setSystemLodingFLgAct,
      setErrorMessageAct,
    } = props;
    // ローディングフラグの初期化
    setSystemLodingFLgAct(false);
    // メッセージの初期化
    setErrorMessageAct();
    document.cookie = `${CSRF_TOKEN_NAME}=; max-age=0`;
    return <Redirect to="/login" />;
  }
  if (systemErrorType === SYSTEM_ERROR_TYPE.CSRF_NONE
    || systemErrorType === SYSTEM_ERROR_TYPE.CLOSE) {
    return <Redirect to="/error" />;
  }
  return <Route {...props} />;
};

export default connect(
  (state) => ({
    systemErrorType: state.common.systemErrorType,
    userInfo: state.common.userInfo,
  }),
  (dispatch) => ({
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    setErrorMessageAct: (string) => dispatch(setErrorMessage(string)),
  }),
)(AuthRoute);
